import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { MaintenanceComponent } from './maintenance';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('maintenance', {
            url: '/maintenance',
            data: {
              authorisationLevel: 0,
              pageTitle: 'Maintenance'
            },
            'views': {
              'multiContent': {
                  template: '<maintenance flex="100"></maintenance>'
              }
          }
        });
};

stateConfig.$inject = ['$stateProvider'];

// a quanto pare togliere il suffisso module e component sblocca la situazione...

export const MaintenanceModule: string = ng
    .module('archiSmall.maintenance', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('maintenance', MaintenanceComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/maintenance/maintenance.module.ts